module.exports = __webpack_public_path__ + "static/img/gzhqrcode.aa833fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gzhqrcode.png
// module id = Yras
// module chunks = 30